import React from 'react'
import "./Testimonials.css"

const Testimonials = () => {
    return (
    
        <div className="testimonials">
            <h3>Trusted by:</h3>    
            <marquee>marcovenier, eleanor.studio, hcl, beenotify.io, open xbox live, azrirridha, all time yatching, panzofi, cognizant, apatics inc.</marquee>
{/*    
            <div className="testimonials__text">
                <h1>Trusted clients</h1>
                <span className="material-icons icon--xl icon--transparent icon--absolute">
                    format_quote
                </span>
                <p className="text--medium">specimen book. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an specimen book. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, unknown</p>
            </div>
            <div className="testimonials__image">
                <img className="image" alt="I'm not sure why this broke?!!" 
                src="https://media.gq-magazine.co.uk/photos/601404648827a103d349dfc3/master/pass/29012020_JAY_HP_.jpg" />
            </div> */}
        </div>
        
    )
}

export default Testimonials